import CustomSuccessAlert from './CustomSuccessAlert'

export default CustomSuccessAlert
